var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,38H30a4,4,0,0,0,0,8H70a4,4,0,0,0,0-8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70,54H30a4,4,0,0,0,0,8H70a4,4,0,0,0,0-8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54,70H30a4,4,0,0,0,0,8H54a4,4,0,0,0,0-8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78,14H66A12,12,0,0,0,54,2H46A12,12,0,0,0,34,14H22A12,12,0,0,0,10,26V86A12,12,0,0,0,22,98H78A12,12,0,0,0,90,86V26A12,12,0,0,0,78,14ZM42,14a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4v8H42ZM82,86a4,4,0,0,1-4,4H22a4,4,0,0,1-4-4V26a4,4,0,0,1,4-4H34v4a4,4,0,0,0,4,4H62a4,4,0,0,0,4-4V22H78a4,4,0,0,1,4,4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsWhite);
export default __webpack_public_path__ + "static/media/Sessions_white.1575e669dc71d2daae9a5a83d919c48a.svg";
export { ForwardRef as ReactComponent };